import { ApiError } from '@/lib/api-error'
import {
  markSessionExpired,
  saveSessionProfile,
} from '../model/session-profile-storage'
import type { SessionProfile } from '../model/session-profile'
import {
  isSessionInvalidated,
  resetSessionInvalidation,
} from './session-expiration'
import { getSessionProfile } from './session-profile-service'

let completedProfile: SessionProfile | null = null
let activeProfileRequest: Promise<SessionProfile> | null = null

export function checkSessionProfileOnce(): Promise<SessionProfile> {
  if (isSessionInvalidated()) {
    return Promise.reject(
      new ApiError({
        message: 'Session expired',
        kind: 'authentication',
        status: 401,
      }),
    )
  }
  if (completedProfile) return Promise.resolve(completedProfile)
  if (activeProfileRequest) return activeProfileRequest

  activeProfileRequest = getSessionProfile()
    .then((profile) => {
      if (isSessionInvalidated()) {
        throw new ApiError({
          message: 'Session expired',
          kind: 'authentication',
          status: 401,
        })
      }
      completedProfile = profile
      saveSessionProfile(profile)
      return profile
    })
    .catch((error: unknown) => {
      if (isExpiredSessionResponse(error)) markSessionExpired()
      throw error
    })
    .finally(() => {
      activeProfileRequest = null
    })

  return activeProfileRequest
}

export function isExpiredSessionResponse(error: unknown) {
  return (
    error instanceof ApiError && (error.status === 401 || error.status === 403)
  )
}

export function isUnauthenticatedSessionResponse(error: unknown) {
  return error instanceof ApiError && error.status === 401
}

export function resetSessionProfileCheck(): void {
  completedProfile = null
  activeProfileRequest = null
  resetSessionInvalidation()
}
